import React from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';

const RecordingOptions = ({
  onChange,
  browserSupport,
  defaultAudio,
  webcam,
  screen,
}) => (
  <div className="d-f">
    <div>
      <input
        id="screen"
        name="screen"
        type="checkbox"
        onChange={onChange}
        checked={screen}
        disabled={!browserSupport.screen}
      />
      <label className="ml-8 mb-0" htmlFor="screen">
        {t('lessons.editor.media_recording.types.screen')}
      </label>
      {!browserSupport.screen && (
        <InfoTooltip
          tooltip={t('questions.question.media_recording.unsupported')}
          className="ml-4 tooltip-fixedWidth"
        />
      )}
    </div>
    <div className="ml-8">
      <input
        id="webcam"
        name="webcam"
        type="checkbox"
        onChange={onChange}
        checked={webcam}
        disabled={!browserSupport.webcam}
      />
      <label className="ml-8 mb-0" htmlFor="webcam">
        {t('lessons.editor.media_recording.types.webcam')}
      </label>
      {!browserSupport.webcam && (
        <InfoTooltip
          tooltip={t('questions.question.media_recording.unsupported')}
          className="ml-4 tooltip-fixedWidth"
        />
      )}
    </div>
    {!defaultAudio && (
      <div className="ml-8">
        <input
          id="audio"
          name="audio"
          type="checkbox"
          onChange={onChange}
          disabled={!browserSupport.audio}
          defaultChecked={browserSupport.audio}
        />
        <label className="ml-8 mb-0" htmlFor="audio">
          {t('lessons.editor.media_recording.types.audio')}
        </label>
        {!browserSupport.audio && (
          <InfoTooltip
            tooltip={t('questions.question.media_recording.unsupported')}
            className="ml-4 tooltip-fixedWidth"
          />
        )}
      </div>
    )}
  </div>
);

export default RecordingOptions;
